export { default } from "./table-menu-item";
